import React, { useState, useEffect, useRef } from "react";
// import "../../../node_modules/react-progress-button/react-progress-button.css"
import { useSnackbar } from "react-simple-snackbar";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { initialState } from "../../initialState";
import { getInvoice } from "../../actions/invoiceActions";
import { getAllItems } from "../../actions/itemActions";
import { toCommas } from "../../utils/utils";
import styles from "./InvoiceDetails.module.css";
import moment from "moment";
import {
  getProfilesByUser,
  updateProfile,
  getProfile,
} from "../../actions/profile";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Box } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import InputBase from "@material-ui/core/InputBase";
import { Container, Grid, Avatar } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import Spinner from "../Spinner/Spinner";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import ProgressButton from "react-progress-button";
import axios from "axios";
import { saveAs } from "file-saver";
import domtoimage from "dom-to-image";
import Modal from "../Payments/Modal";
import PaymentHistory from "./PaymentHistory";
import {
  useMediaQuery,
  useTheme,
  createTheme,
  ThemeProvider,
} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import fallbackLogo from "../../assets/logo.jpg";
const InvoiceDetails = () => {
  const location = useLocation();
  const [state, setState] = useState(0);
  const [invoiceData, setInvoiceData] = useState(initialState);
  const [commission, setCommission] = useState(0);
  const [Expense, setExpense] = useState(0);
  const [rates, setRates] = useState(0);
  const [vat, setVat] = useState(0);
  const [currency, setCurrency] = useState("");
  const [subTotal, setSubTotal] = useState(0);
  const [total, setTotal] = useState(0);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [client, setClient] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [signatureDataUrl, setSignatureDataUrl] = useState(null);
  const [type, setType] = React.useState("");
  const [status, setStatus] = useState("");
  const [company, setCompany] = useState({});
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { id } = useParams();
  //console.log("id", id);
  const { invoice } = useSelector((state) => state.invoices);
  //console.log(invoice);
  const items = useSelector((state) => state.items.items);
  const { profiles } = useSelector((state) => state.profiles);
  console.log("Profiles", profiles);
  const dispatch = useDispatch();
  const history = useHistory();
  const cameFromTodayBookings = Boolean(location.state?.fromTodayBookings);
  const [sendStatus, setSendStatus] = useState(null);
  const [downloadStatus, setDownloadStatus] = useState(null);
  const [jpgDownloadStatus, setJpgDownloadStatus] = useState(null);
  const [printStatus, setPrintStatus] = useState(null);
  // eslint-disable-next-line
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const user = JSON.parse(localStorage.getItem("profile"));
  const displayProfile = profiles?._id ? profiles : user?.userProfile;
  const invoiceCaptureRef = useRef(null);
  const logoSrc = (() => {
    const logo = displayProfile?.logo;

    if (!logo) return fallbackLogo;
    if (logo.startsWith("http") || logo.startsWith("data:")) return logo;

    const normalizedLogo = logo.startsWith("/") ? logo : `/${logo}`;
    return `${process.env.REACT_APP_API}${normalizedLogo}`;
  })();

  const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
      "& > *": {
        margin: theme.spacing(1),
      },
    },
    large: {
      width: theme.spacing(12),
      height: theme.spacing(12),
    },
    table: {
      minWidth: 650,
    },

    headerContainer: {
      // display: 'flex'

      paddingTop: theme.spacing(1),
      paddingLeft: theme.spacing(5),
      paddingRight: theme.spacing(1),
      backgroundColor: "red",
      borderRadius: "10px 10px 0px 0px",
    },
    wpContainer: {
      display: "flex",
      alignItems: "center",
    },
    whatsappIcon: {
      height: "3rem",
      width: "3rem",
      cursor: "pointer",
    },
    circularProgress: {
      marginLeft: "8px", // Add margin for mobile view
    },
  }));

  const classes = useStyles();
  const safeNumber = (value) => Number(value || 0);
  const getLineTotal = (item) =>
    safeNumber(item?.quantity) * safeNumber(item?.unitPrice);
  const activitySubtotal = (invoiceData?.selling || []).reduce(
    (total, item) => total + getLineTotal(item),
    0
  );
  const tourSubtotal = (invoiceData?.payable || []).reduce(
    (total, item) => total + getLineTotal(item),
    0
  );
  const invoiceRemarks = (invoiceData?.notes || invoice?.notes || "").trim();
  const agentName = client?.name || invoiceData?.client?.name || "Agent";
  const businessName =
    company?.businessName ||
    displayProfile?.businessName ||
    company?.name ||
    "-";
  const bookingType = (invoiceData?.bookingType || "FIT").toString().trim().toUpperCase();
  const bookingTypeStyles = {
    FIT: {
      backgroundColor: "#1b8f4b",
      gradient: "linear-gradient(90deg, #1b8f4b 0%, #28a745 100%)",
      color: "#ffffff",
      badgeBackground: "#e8f5e9",
      badgeColor: "#1b8f4b",
      badgeBorderColor: "#b7dfc3",
    },
    GROUP: {
      backgroundColor: "#c62828",
      gradient: "linear-gradient(90deg, #b71c1c 0%, #e53935 100%)",
      color: "#ffffff",
      badgeBackground: "#ffebee",
      badgeColor: "#c62828",
      badgeBorderColor: "#ef9a9a",
    },
  };
  const currentBookingTypeStyle = bookingTypeStyles[bookingType] || {
    backgroundColor: "#546e7a",
    gradient: "linear-gradient(90deg, #455a64 0%, #607d8b 100%)",
    color: "#ffffff",
    badgeBackground: "#f1f3f4",
    badgeColor: "#455a64",
    badgeBorderColor: "#cfd8dc",
  };

  useEffect(() => {
    dispatch(getInvoice(id));
  }, [id, dispatch, location]);

  useEffect(() => {
    if (invoice) {
      //Automatically set the default invoice values as the ones in the invoice to be updated

      setExpense(invoice.expense);
      setCommission(invoice.commission);
      setInvoiceData(invoice);
      setRates(invoice.rates);
      setClient(invoice.client);
      setSupplier(invoice.supplier);
      setType(invoice.type);
      setStatus(invoice.status);
      setSelectedDate(invoice.dueDate);
      setVat(invoice.vat);
      setCurrency(invoice.currency);
      setSubTotal(invoice.subTotal);
      setTotal(invoice.total);
      setCompany(invoice?.businessDetails?.data);
      setSignatureDataUrl(invoice.signatureDataUrl);
    }
  }, [invoice]);
  useEffect(() => {
    dispatch(
      // getItemsByUser({ search: user?.result._id || user?.result?.googleId })
      getAllItems()
    );
    // eslint-disable-next-line
  }, [dispatch]);
  useEffect(() => {
    // dispatch(getProfilesByUser({ search: user?.result?._id }))
    dispatch(getProfile(user?.userProfile?._id));
  }, [location, dispatch]);
  //Get the total amount paid
  let totalAmountReceived = 0;
  for (var i = 0; i < invoice?.paymentRecords?.length; i++) {
    totalAmountReceived += Number(invoice?.paymentRecords[i]?.amountPaid);
  }

  const editInvoice = (id) => {
    history.push(`/edit/invoice/${id}`);
  };
  const goBackToTodayBookings = () => {
    history.push({
      pathname: "/todayBookings",
      state: { fromDashboard: true },
    });
  };

  const createAndPrintPdf = () => {
    setPrintStatus("loading");
    axios
      .post(
        `${process.env.REACT_APP_API}/create-pdf/${invoice.invoiceNumber}`,
        {
          name: invoice.client.name,
          agentCode: invoice.client.agentCode,
          date: invoice.date,
          id: invoice.invoiceNumber,
          notes: invoice.notes,
          subTotal: toCommas(invoice.subTotal),
          total: invoice.total,
          type: invoice.type,
          bookingType: invoice.bookingType,
          vat: invoice.vat,
          selling: invoice.selling,
          payable: invoice.payable,
          pax: invoice.pax,
          commission: invoice.commission,
          expense: invoice.expense,
          status: invoice.status,
          totalAmountReceived: toCommas(totalAmountReceived),
          balanceDue: toCommas(total - totalAmountReceived),
          company: company,
        }
      )
      .then(() =>
        axios.get(
          `${process.env.REACT_APP_API}/fetch-pdf/${invoice.invoiceNumber}`,
          {
            responseType: "blob",
          }
        )
      )
      .then((res) => {
        const pdfBlob = new Blob([res.data], { type: "application/pdf" });
        const downloadUrl = window.URL.createObjectURL(pdfBlob);
        setPrintStatus("success");

        // Open a new browser window for printing the PDF
        const printWindow = window.open(downloadUrl, "_blank");

        // Wait for the PDF to load, then trigger printing
        printWindow.onload = () => {
          printWindow.print();
          // You can close the print window automatically if needed
          // printWindow.close();
        };
      });
    // .then((res) => {
    //   const pdfBlob = new Blob([res.data], { type: "application/pdf" });
    //   // const downloadUrl = window.URL.createObjectURL(pdfBlob);
    //   // setDownloadStatus("success");
    //   // window.open(downloadUrl, "_blank");
    //   saveAs(pdfBlob, `order${invoice.invoiceNumber}.pdf`)
    //   const downloadUrl= `http://orders.sadhanaayurvedics.com/files/Exported-order/order${invoice.invoiceNumber}.pdf`
    //   window.open(downloadUrl,'_blank')
    //   setDownloadStatus("success");
    // });
  };
  const createAndDownloadPdf = () => {
    setDownloadStatus("loading");
    axios
      .post(
        `${process.env.REACT_APP_API}/create-pdf/${invoice.invoiceNumber}`,
        {
          name: invoice.client.name,
          agentCode: invoice.client.agentCode,
          date: invoice.date,
          id: invoice.invoiceNumber,
          notes: invoice.notes,
          subTotal: toCommas(invoice.subTotal),
          total: invoice.total,
          type: invoice.type,
          bookingType: invoice.bookingType,
          vat: invoice.vat,
          selling: invoice.selling,
          payable: invoice.payable,
          pax: invoice.pax,
          commission: invoice.commission,
          expense: invoice.expense,
          status: invoice.status,
          totalAmountReceived: toCommas(totalAmountReceived),
          balanceDue: toCommas(total - totalAmountReceived),
          company: company,
          invoiceData: invoiceData,
          profiles: profiles,
        }
      )
      .then(() =>
        axios.get(
          `${process.env.REACT_APP_API}/fetch-pdf/${invoice.invoiceNumber}`,
          {
            responseType: "blob",
          }
        )
      )
      .then((res) => {
        const pdfBlob = new Blob([res.data], { type: "application/pdf" });
        // const downloadUrl = window.URL.createObjectURL(pdfBlob);
        // setDownloadStatus("success");
        // window.open(downloadUrl, "_blank");
        saveAs(pdfBlob, `order${invoice.invoiceNumber}.pdf`);
        const downloadUrl = `https://asn.mindtree.co.th/files/Exported-order/order${invoice.invoiceNumber}.pdf`;
        window.open(downloadUrl, "_blank");
        setDownloadStatus("success");
      });
  };
  const downloadInvoiceAsImage = async () => {
    if (!invoiceCaptureRef.current) return;

    let offscreenHost = null;

    try {
      setJpgDownloadStatus("loading");
      const node = invoiceCaptureRef.current;
      if (document.fonts?.ready) {
        await document.fonts.ready;
      }

      const images = Array.from(node.querySelectorAll("img"));
      await Promise.all(
        images.map(
          (image) =>
            image.complete
              ? Promise.resolve()
              : new Promise((resolve) => {
                  image.onload = () => resolve();
                  image.onerror = () => resolve();
                })
        )
      );

      const captureWidth = 1200;
      const captureRoot = node.cloneNode(true);

      offscreenHost = document.createElement("div");
      offscreenHost.style.position = "fixed";
      offscreenHost.style.left = "-10000px";
      offscreenHost.style.top = "0";
      offscreenHost.style.width = `${captureWidth}px`;
      offscreenHost.style.background = "#ffffff";
      offscreenHost.style.pointerEvents = "none";
      offscreenHost.style.overflow = "visible";
      offscreenHost.style.zIndex = "-1";

      captureRoot.style.width = `${captureWidth}px`;
      captureRoot.style.minWidth = `${captureWidth}px`;
      captureRoot.style.margin = "0";
      captureRoot.style.transform = "none";
      captureRoot.style.boxSizing = "border-box";
      captureRoot.style.overflow = "visible";

      // Expand scrollable MUI table containers so the export renders the full
      // content instead of capturing internal scrollbars.
      const scrollableNodes = captureRoot.querySelectorAll(
        ".MuiTableContainer-root, [class*='MuiTableContainer-root']"
      );
      scrollableNodes.forEach((element) => {
        element.style.overflow = "visible";
        element.style.overflowX = "visible";
        element.style.overflowY = "visible";
        element.style.maxHeight = "none";
        element.style.height = "auto";
      });

      offscreenHost.appendChild(captureRoot);
      document.body.appendChild(offscreenHost);

      const captureHeight = captureRoot.scrollHeight;
      const dataUrl = await domtoimage.toPng(captureRoot, {
        bgcolor: "#ffffff",
        cacheBust: true,
        width: captureWidth,
        height: captureHeight,
        style: {
          width: `${captureWidth}px`,
          minWidth: `${captureWidth}px`,
          margin: "0",
          transform: "none",
          boxSizing: "border-box",
          overflow: "visible",
        },
      });

      const link = document.createElement("a");
      link.download = `invoice-${invoice?.invoiceNumber || "preview"}.png`;
      link.href = dataUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setJpgDownloadStatus("success");
    } catch (error) {
      console.error("Failed to export invoice image:", error);
      setJpgDownloadStatus("error");
    } finally {
      if (offscreenHost?.parentNode) {
        offscreenHost.parentNode.removeChild(offscreenHost);
      }
    }
  };
  // const downloadPdf = (fileName) => {
  //   const apiUrl = `${process.env.REACT_APP_API}/fetch-pdf/${fileName}`;
  //   axios
  //     .get(apiUrl, { responseType: "blob" })
  //     .then((response) => {
  //       const file = new Blob([response.data], { type: "application/pdf" });
  //       saveAs(file, fileName);
  //     })
  //     .catch((error) => {
  //       console.error("Error downloading PDF:", error);
  //     });
  // };

  //SEND PDF INVOICE VIA EMAIL
  const sendPdf = (e) => {
    e.preventDefault();
    setSendStatus("loading");
    setLoading(true);
    axios
      .post(`${process.env.REACT_APP_API}/send-pdf-whatsapp`, {
        name: invoice.client.name,
        agentCode: invoice.client.agentCode,
        date: invoice.date,
        id: invoice.invoiceNumber,
        notes: invoice.notes,
        subTotal: toCommas(invoice.subTotal),
        total: invoice.total,
        type: invoice.type,
        bookingType: invoice.bookingType,
        vat: invoice.vat,
        selling: invoice.selling,
        payable: invoice.payable,
        pax: invoice.pax,
        commission: invoice.commission,
        expense: invoice.expense,
        status: invoice.status,
        totalAmountReceived: toCommas(totalAmountReceived),
        balanceDue: toCommas(total - totalAmountReceived),
        company: company,
      })
      .then((res) => {
        const pdfBlob = new Blob([res.data], { type: "application/pdf" });
        // //console.log(resres.data)
        const downloadUrl = window.URL.createObjectURL(pdfBlob);
        setSendStatus("success");
        const encodedFilePath = encodeURIComponent(downloadUrl);
        //console.log("Client Phone Number", invoice.client.phone);
        const whatsappURL = `https://wa.me/${invoice.client.phone}?text=https://asn.mindtree.co.th/files/Exported-order/order${invoice.invoiceNumber}.pdf`;

        window.open(whatsappURL, "_blank");

        // window.open(res.data.whatsappURL, "_blank");
      })
      // .then(() => //console.log("invoice sent successfully"))
      .then(() => {
        setSendStatus("success");
        setLoading(false);
        history.push("/dashboard");
      })
      .catch((error) => {
        //console.log(error);
        setSendStatus("error");
      });
  };

  const iconSize = {
    height: "18px",
    width: "18px",
    marginRight: "10px",
    color: "gray",
  };
  const [open, setOpen] = useState(false);

  function checkStatus() {
    return totalAmountReceived >= total
      ? "green"
      : status === "Partial"
      ? "#1976d2"
      : status === "Paid"
      ? "green"
      : status === "Unpaid"
      ? "red"
      : "red";
  }

  if (!invoice) {
    return <Spinner />;
  }
  // const findItemNameById = (itemId) => {
  //   //console.log("parameter"+itemId);
  //   const item = items.find((item) => item._id ==itemId);
  //   //console.log(user)
  //   return item ? item.name : "";
  // };
  const colorTheme = createTheme({
    palette: {
      primary: {
        main: "#ef7f1a",
      },
    },
  });
  return (
    <div className={styles.PageLayout}>
      <div
        className={styles.buttons}
        style={{
          display: "flex",
          flexDirection: isSmallScreen ? "column" : "row",
          gap: "10px",
        }}
      >
        {cameFromTodayBookings && (
          <div style={{ width: isSmallScreen ? "90%" : "auto" }}>
            <button
              className={styles.btn}
              onClick={goBackToTodayBookings}
            >
              <ArrowBackIcon style={iconSize} />
              Back to Today's Bookings
            </button>
          </div>
        )}
        <div style={{ width: isSmallScreen ? "90%" : "auto" }}>
          {user?.result?.userType === "admin" && (
            <button
              className={styles.btn}
              onClick={() => editInvoice(invoiceData._id)}
            >
              <BorderColorIcon style={iconSize} />
              Edit Booking
            </button>
          )}
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginRight: "10px",
            flexWrap: "wrap",
          }}
        >
             <ProgressButton
            onClick={downloadInvoiceAsImage}
            state={jpgDownloadStatus}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "40px",
              marginTop: "7px",
              borderRadius: "24px",
              padding: "8px 18px",
              width: isSmallScreen ? "100%" : "auto",
              cursor: "pointer",
              color: "#ef7f1a",
            }}
          >
            Download Image
          </ProgressButton>
          <ProgressButton
            onClick={createAndDownloadPdf}
            state={downloadStatus}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              backgroundColor: "Transparent",
              color: "#000000",
              border: "none",
              borderRadius: "24px",
              padding: "8px",
              height: "40px",
              width: isSmallScreen ? "100%" : "10rem",
              marginTop: "7px",
              cursor: "pointer",
            }}
            >
            Download PDF
          </ProgressButton>
       
          {/* <ProgressButton
            onClick={createAndPrintPdf}
            state={printStatus}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              backgroundColor: "Transparent",
              color: "#000000",
              border: "none",
              borderRadius: "24px",
              padding: "8px",
              height: "40px",
              width: isSmallScreen ? "100%" : "10rem",
              marginTop: "7px",
              cursor: "pointer",
            }}
          >
            Print
          </ProgressButton> */}
          {/* <Button onClick={()=>IminPrint()}>
              IMIN Print
            </Button> */}
          {/* // if (clientData.phone.trim() === '') {
    //   newErrors.phone = 'Phone is required';
    //   isValid = false;
    // }else if(clientData.phone.length<10||clientData.phone.length>12){
    //   newErrors.phone = 'Please enter a valid phone number.';
    //   isValid = false;} */}

          {/* <ThemeProvider theme={colorTheme}>
            <div className={classes.wpContainer}>
              {loading ? (
                <CircularProgress
                  className={isSmallScreen ? classes.circularProgress : ""}
                />
              ) : (
                <img
                  className={classes.whatsappIcon}
                  src="https://www.sharethis.com/wp-content/uploads/2017/05/WhatsApp.png"
                  alt=""
                  onClick={sendPdf}
                />
              )}
            </div>
          </ThemeProvider> */}
        </div>
      </div>

      {invoice?.paymentRecords.length !== 0 && (
        <PaymentHistory paymentRecords={invoiceData?.paymentRecords} />
      )}

      <Modal open={open} setOpen={setOpen} invoice={invoice} />
      <div className={styles.invoiceLayout} ref={invoiceCaptureRef}>
        {/* Title Section */}
        <Box
          sx={{
            width: "100%",
            background: currentBookingTypeStyle.gradient,
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            position: "relative",
            padding: "12px 18px",
            borderRadius: "14px 14px 0 0",
            boxShadow: "0 10px 24px rgba(17, 24, 39, 0.12)",
          }}
        >
          <Box
            component="div"
            sx={{
              position: "absolute",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
              color: currentBookingTypeStyle.color,
              textAlign: "center",
              fontWeight: 700,
              lineHeight: 1,
              fontSize: "18px",
              letterSpacing: "0.03em",
              textTransform: "uppercase",
              width: "calc(100% - 200px)",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              pointerEvents: "none",
              fontFamily: "Arial, Helvetica, sans-serif",
            }}
          >
            CORAL ISLAND TOUR REPORT
          </Box>
          <Box
            sx={{
              marginLeft: "auto",
              px: 1.75,
              py: 0.65,
              borderRadius: "999px",
              border: "1px solid",
              borderColor: currentBookingTypeStyle.badgeBorderColor,
              backgroundColor: currentBookingTypeStyle.badgeBackground,
              color: currentBookingTypeStyle.badgeColor,
              fontSize: "0.75rem",
              fontWeight: 800,
              letterSpacing: "0.08em",
              textTransform: "uppercase",
              boxShadow: "0 6px 14px rgba(0,0,0,0.10)",
              whiteSpace: "nowrap",
              zIndex: 1,
            }}
          >
            {bookingType}
          </Box>
        </Box>

        <Container maxWidth="lg">
          {/* Top Section with Two Halves */}
          <Grid container spacing={3} sx={{ marginBottom: "28px" }}>
            {/* Left Half - Logo and Company Details */}
            <Grid item xs={12} md={6}>
              <Box sx={{ padding: "10px" }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    flexDirection: isSmallScreen ? "column" : "row",
                    justifyContent: isSmallScreen ? "center" : "flex-start",
                    marginBottom: "18px",
                  }}
                >
                  <Box
                    sx={{
                      width: 120,
                      minWidth: 120,
                      height: 120,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "8px",
                      border: "1px solid #e8e8e8",
                      backgroundColor: "#fff",
                      padding: "10px",
                      "& img": {
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        backgroundColor: "transparent",
                        maxWidth: "100%",
                        maxHeight: "100%",
                      },
                    }}
                  >
                  <img
                    src={logoSrc}
                    alt="ASN Logo"
                    crossOrigin="anonymous"
                    onError={(event) => {
                      event.currentTarget.src = fallbackLogo;
                      }}
                    />
                  </Box>
                  <Box
                    sx={{
                      textAlign: isSmallScreen ? "center" : "left",
                      flex: 1,
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        marginBottom: "6px",
                        lineHeight: 1.2,
                      }}
                    >
                      {displayProfile?.businessName}
                    </Typography>
                    {displayProfile?.contactAddress && (
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#666",
                          lineHeight: 1.6,
                          maxWidth: isSmallScreen ? "unset" : "340px",
                        }}
                      >
                        {displayProfile.contactAddress}
                      </Typography>
                    )}
                    {displayProfile?.phone && (
                      <Typography
                        variant="body2"
                        sx={{ color: "#666", lineHeight: 1.6 }}
                      >
                        {displayProfile.phone}
                      </Typography>
                    )}
                  </Box>
                </Box>

                {/* Pax Details - More structured layout */}
                <Grid container spacing={2}>
                  <TableContainer component={Paper}>
                    <Table
                      size="small"
                      aria-label="tour details table"
                      style={{ border: "1px solid #ddd" }}
                    >
                      <TableBody>
                        <TableRow>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{ border: "1px solid #ddd" ,fontSize:"16px"}}
                          >
                            <strong>Adult</strong>
                          </TableCell>
                          <TableCell style={{ border: "1px solid #ddd",fontSize:"16px" }}>
                            {invoiceData?.adult || 0}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{ border: "1px solid #ddd" ,fontSize:"16px"}}
                          >
                            <strong>Child</strong>
                          </TableCell>
                          <TableCell style={{ border: "1px solid #ddd" ,fontSize:"16px"}}>
                            {invoiceData?.child || 0}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{ border: "1px solid #ddd",fontSize:"16px" }}
                          >
                            <strong>Tour Leader</strong>
                          </TableCell>
                          <TableCell style={{ border: "1px solid #ddd" ,fontSize:"16px"}}>
                            {invoiceData?.tourLeader || "-"}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{ border: "1px solid #ddd",fontSize:"16px" }}
                          >
                            <strong>Guide</strong>
                          </TableCell>
                          <TableCell style={{ border: "1px solid #ddd" ,fontSize:"16px"}}>
                            {invoiceData?.guide || "-"}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </Box>
            </Grid>
            {/* Right Half - Details with Borders */}
            <Grid item xs={12} md={6}>
              <Paper
                elevation={0}
                sx={{
                  border: "1px solid #ddd",
                  height: "100%",
                }}
                style={{ margin: "20px auto" }}
              >
                <Table style={{ borderCollapse: "collapse" }}>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        style={{
                          backgroundColor: "#fff3e0",
                          width: "40%",
                          border: "1px solid #CCCCCC",
                          padding: "8px",
                         fontSize:"16px"
                        }}
                      >
                        <strong>Date</strong>
                      </TableCell>
                      <TableCell
                        style={{
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        {invoice
                          ? moment(invoice.date).format("DD-MM-YYYY")
                          : moment().format("DD-MM-YYYY")}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          backgroundColor: "#fff3e0",
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        <strong>Bill Number</strong>
                      </TableCell>
                      <TableCell
                        style={{
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        {invoiceData?.invoiceNumber}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          backgroundColor: "#fff3e0",
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        <strong>Booking Type</strong>
                      </TableCell>
                      <TableCell
                        style={{
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        <Box
                          component="span"
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            px: 1.25,
                            py: 0.5,
                            borderRadius: "999px",
                            border: "1px solid",
                            borderColor: currentBookingTypeStyle.badgeBorderColor,
                            backgroundColor: currentBookingTypeStyle.badgeBackground,
                            color: currentBookingTypeStyle.badgeColor,
                            fontSize: "0.75rem",
                            fontWeight: 800,
                            letterSpacing: "0.08em",
                            textTransform: "uppercase",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {bookingType}
                        </Box>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          backgroundColor: "#fff3e0",
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        <strong>Agent</strong>
                      </TableCell>
                      <TableCell
                        style={{
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        {client?.name}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          backgroundColor: "#fff3e0",
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        <strong>Nationality</strong>
                      </TableCell>
                      <TableCell
                        style={{
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        {invoiceData?.nationality}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          backgroundColor: "#fff3e0",
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        <strong>Hotel</strong>
                      </TableCell>
                      <TableCell
                        style={{
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        {invoiceData?.hotel}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          backgroundColor: "#fff3e0",
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        <strong>Room Number</strong>
                      </TableCell>
                      <TableCell
                        style={{
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        {invoiceData?.roomNumber}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          backgroundColor: "#fff3e0",
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        <strong>Guest Code</strong>
                      </TableCell>
                      <TableCell
                        style={{
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        {invoiceData?.guestCode}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          backgroundColor: "#fff3e0",
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        <strong>Ref Num</strong>
                      </TableCell>
                      <TableCell
                        style={{
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        {invoiceData?.refNum}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Paper>
            </Grid>
          </Grid>

          {/* Tables Section */}
          <Grid container spacing={3}>
            {/* Activity Report Table */}
            <Grid item xs={12} md={6}>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        colSpan={4}
                        style={{
                          backgroundColor: "#f5f5f5",
                          fontWeight: "bold",
                          textAlign: "center",
                          fontSize: "1.1rem",
                        }}
                      >
                        Activity Report
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: "bold" ,fontSize:"16px"}}>
                        Particulars
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold",fontSize:"16px" }}>
                        Commission
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold",fontSize:"16px" }}>Unit</TableCell>
                      <TableCell style={{ fontWeight: "bold" ,fontSize:"16px"}}>Income</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {invoiceData?.selling?.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell style={{ fontSize:"16px" }}>{item.itemName}</TableCell>
                        <TableCell style={{ fontSize:"16px" }}>
                          {toCommas(safeNumber(item?.commission?.commissionValue))}
                        </TableCell >
                        <TableCell style={{ fontSize:"16px" }}>{item.quantity}</TableCell>
                        <TableCell style={{ fontSize:"16px" }}>{toCommas(getLineTotal(item))}</TableCell>
                      </TableRow>
                    ))}
                    {/* Subtotal Row */}
                    <TableRow>
                      <TableCell
                        colSpan={3}
                        style={{ fontWeight: "bold", textAlign: "left",fontSize:"18px" }}
                      >
                        Sub Total
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold",fontSize:"18px" }}>
                        {toCommas(activitySubtotal)}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>

       {/* Tour Bill Table */}
<Grid item xs={12} md={6}>
  <TableContainer component={Paper}>
    <Table sx={{ width: "100%", tableLayout: "fixed" }}>
      {/* Column Widths */}
      <colgroup>
     <col style={{ width: "60%" }} />
    <col style={{ width: "13%" }} />
    <col style={{ width: "13%" }} />
    <col style={{ width: "14%" }} />
      </colgroup>

      <TableHead>
        <TableRow>
          <TableCell
            colSpan={4}
            sx={{
              backgroundColor: "#f5f5f5",
              fontWeight: "bold",
              textAlign: "center",
              fontSize: "1.1rem",
            }}
          >
            Tour Bill
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell
            sx={{
              fontWeight: "bold",
              fontSize: "16px",
            }}
          >
            Particulars
          </TableCell>

          <TableCell
            sx={{
              fontWeight: "bold",
              fontSize: "16px",
              textAlign: "center",
            }}
          >
            Unit
          </TableCell>

          <TableCell
            sx={{
              fontWeight: "bold",
              fontSize: "16px",
              textAlign: "center",
            }}
          >
            Rate
          </TableCell>

          <TableCell
            sx={{
              fontWeight: "bold",
              fontSize: "16px",
              textAlign: "center",
            }}
          >
            Total
          </TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {invoiceData?.payable?.map((item, index) => (
          <TableRow key={index}>
            <TableCell
              sx={{
                fontSize: "16px",
                whiteSpace: "normal",
                wordBreak: "break-word",
              }}
            >
              {item.itemName}
            </TableCell>

            <TableCell
              sx={{
                fontSize: "16px",
                textAlign: "center",
              }}
            >
              {item.quantity}
            </TableCell>

            <TableCell
              sx={{
                fontSize: "16px",
                textAlign: "center",
              }}
            >
              {toCommas(safeNumber(item.unitPrice))}
            </TableCell>

            <TableCell
              sx={{
                fontSize: "16px",
                textAlign: "center",
              }}
            >
              {toCommas(getLineTotal(item))}
            </TableCell>
          </TableRow>
        ))}

        <TableRow>
          <TableCell
            colSpan={3}
            sx={{
              fontWeight: "bold",
              textAlign: "left",
              fontSize: "18px",
            }}
          >
            Sub Total
          </TableCell>

          <TableCell
            sx={{
              fontWeight: "bold",
              fontSize: "18px",
              textAlign: "center",
            }}
          >
            {toCommas(tourSubtotal)}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  </TableContainer>
</Grid>
          </Grid>

          {/* Summary Section */}
          <Box
            sx={{
              marginTop: "34px",
            }}
          >
            <Paper
              sx={{
                backgroundColor: "#ffeb3b",
                padding: "20px",
              }}
            >
              

              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  alignItems: "center",
                  marginBottom: "15px",
                  gap: "16px",
                }}
              >
                <Typography
                  variant="h5"
                  sx={{ whiteSpace: "nowrap", fontSize: { xs: "1.1rem", md: "1.35rem" } }}
                >
                  Commission: {currency} {toCommas(commission)}
                </Typography>

                <Typography
                  variant="h5"
                  sx={{
                    color: "red",
                    whiteSpace: "nowrap",
                    textAlign: "right",
                    fontSize: { xs: "1.1rem", md: "1.35rem" },
                  }}
                >
                  Total Expense: {currency} {toCommas(Expense)}
                </Typography>
              </Box>

              <Box
                sx={{
                  width: "100%",
                  borderTop: "1px solid rgba(0, 0, 0, 0.1)",
                  paddingTop: "15px",
                }}
              >
                {(() => {
                  const balanceColor =
                    commission > Expense ? "#2e7d32" : "#c62828";
                  const balanceLabel =
                    commission > Expense
                      ? "Total Payable To"
                      : "Total Payable To";
                  const balanceName =
                    commission > Expense ? agentName : businessName;
                  const balanceAmount = `${commission > Expense ? "+" : "-"} ${toCommas(
                    Math.abs(commission - Expense)
                  )}`;
                  return (
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: "bold",
                    width: "100%",
                    textAlign: "center",
                    fontSize: { xs: "1.1rem", md: "1.35rem" },
                    lineHeight: 1.3,
                  }}
                >
                  <Box component="span" sx={{ color: balanceColor, whiteSpace: "nowrap" }}>
                    {balanceLabel}: {balanceName} 
                  </Box>{" "}
                  <Box component="span" sx={{ color: balanceColor, whiteSpace: "nowrap" }}>
                    {currency} {balanceAmount}
                  </Box>
                </Typography>
                  );
                })()}
              </Box>
            </Paper>
          </Box>

          {invoiceRemarks && (
            <Box
              sx={{
                marginTop: "22px",
                border: "1px solid #e5e5e5",
                borderRadius: "8px",
                padding: "16px 18px",
                backgroundColor: "#fff",
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 700, marginBottom: "8px", color: "#37474f" }}
              >
                Remarks
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "#546e7a", whiteSpace: "pre-wrap", lineHeight: 1.7 }}
              >
                {invoiceRemarks}
              </Typography>
            </Box>
          )}

          {/* Footer */}
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "22px 0 8px",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                textAlign: "center",
                fontWeight: "bold",
                width: "100%",
              }}
            >
              Thanks for Your Business
            </Typography>
          </Box>
        </Container>
      </div>
    </div>
  );
};

export default InvoiceDetails;
